import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionLabel } from "@/components/primitives";
import { whoWeWorkWith } from "@/data/content";

export default function WhoWeWorkWith() {
  return (
    <section
      data-testid="who-section"
      className="border-t border-fs-border bg-fs-bg2 py-24 lg:py-32"
    >
      <div className="fs-shell">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <SectionLabel testId="who-label">Who We Work With</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 fs-h2">
                Built for service businesses
                <br className="hidden sm:block" /> with ambition.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <p className="fs-body">
                These are the businesses we build for. Each engagement is shaped
                around the way you operate and where you want to go next.
              </p>
            </Reveal>
          </div>
        </div>

        <StaggerGroup className="mt-16 grid gap-px border border-fs-border bg-fs-border sm:grid-cols-2 lg:grid-cols-5">
          {whoWeWorkWith.map((item) => {
            const Icon = item.icon;
            return (
              <StaggerItem key={item.title}>
                <div
                  className="group flex h-full flex-col items-start gap-6 bg-fs-bg2 p-7 transition-colors duration-300 hover:bg-fs-card"
                  data-testid={`who-item-${item.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <span className="flex h-12 w-12 items-center justify-center border border-fs-border text-fs-gold transition-colors duration-300 group-hover:border-fs-gold/50">
                    <Icon className="h-5 w-5" strokeWidth={1.4} />
                  </span>
                  <h3 className="font-serif text-lg leading-snug text-fs-ink">
                    {item.title}
                  </h3>
                </div>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
}
